// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ApkLoanFeeService = {};

ApkLoanFeeService.addApkLoanFeeService = function (data) {
  return lossClient({
    url: `/ApkLoanFee/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApkLoanFeeService.editApkLoanFeeService = function (data) {
  console.log("editApkLoanFeeService", data?.data?.LoanFees);

  return lossClient({
    url: "/ApkLoanFee/edit",
    method: "PUT",
    headers: {
      "x-requestId": data?.id,
    },
    // body: data?.data?.LoanFees,
    data: {
      LoanFees: data?.data?.LoanFees,
    },
  });
};

ApkLoanFeeService.getAddApkLoanFeeService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;
  console.log("apkLoanItemCSTFee ", data);

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    applicationid: data.applicationid || "",
    totalOTR: data.totalOTR || "",
  });

  return lossClient({
    url: `/ApkLoanFee/getAdd?${params.toString()}`,
    method: "get",
  });
};

ApkLoanFeeService.getEditApkLoanFeeService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;
  console.log("apkLoanItemCSTFee ", data);

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    applicationid: data.applicationid || "",
    step: data.step || "",
  });

  return lossClient({
    url: `/ApkLoanFee/getEdit?${params.toString()}`,
    method: "get",
  });
};

export default ApkLoanFeeService;
